// extracted by mini-css-extract-plugin
export default {"w-full":"Snapshot_w-full__PAYt3","nav":"Snapshot_nav__vgxqv","item":"Snapshot_item__09qJN","active":"Snapshot_active__FdIKY"};